export const LOGIN_HERO_FEATURE_KEYS = [
  'auth.heroFeatureMultiTenant',
  'auth.heroFeaturePoiTourControl',
  'auth.heroFeatureMultilingual',
  'auth.heroFeatureRealtimeAnalytics',
] as const
